import * as React from "react";
import { SVGProps } from "react";

const Xdai = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 256 255"
    {...props}
  >
    <style>{".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}"}</style>
    <g id="Page-1">
      <g id="Artboard">
        <g id="Group-6">
          <path
            id="Fill-1"
            fill="#48a9a6"
            fillRule="evenodd"
            d="M128 0c70.6 0 128 57.3 128 127.9s-57.4 127.9-128 127.9S0 198.5 0 127.9 57.4 0 128 0z"
            clipRule="evenodd"
          />
          <path id="Fill-2" d="M62.3 88.6h52.6V62.3H62.3z" className="st1" />
          <path id="Fill-3" d="M141.1 88.6h52.6V62.3h-52.6z" className="st1" />
          <path
            id="Fill-4"
            d="M193.7 141.1h-26.3v26.3h-26.3v26.3h52.6z"
            className="st1"
          />
          <path
            id="Fill-5"
            d="M114.9 193.7v-26.3H88.6v-26.3H62.3v52.6z"
            className="st1"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Xdai;
